import {
  BootstrapOptions,
  Component,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexMarkers,
  ApexTitleSubtitle,
  ApexFill,
  ApexYAxis,
  ApexXAxis,
  ApexTooltip,
  ApexStroke,
  ApexAnnotations,
  ApexNonAxisChartSeries,
} from 'ng-apexcharts';
import { interval, Subscription } from 'rxjs';
import { map, take, single } from 'rxjs/operators';
import {
  LegendItemClickEvent,
  CategoryAxis,
  Legend,
  Series,
  SeriesLabelsContentArgs,
  LineStyle,
} from '@progress/kendo-angular-charts';
import { Group, Text } from '@progress/kendo-drawing';
import { DecimalPipe, formatDate } from '@angular/common';
import { SharedService } from '../../shared/shared.service';
import {
  BillingType,
  prepaidSummary,
  Roles,
  superadmin_graphColors,
  SweetAlertIcon,
} from '../../shared/constants/enum';

import { Store, select } from '@ngrx/store';
import {
  getadmindashboardResponse,
  getadminFlatwiseConsmptionsdashboardResponse,
} from '../../store/dashboard/dashboard-selector';
import {
  getAdminDashboard,
  getAdminFlatwiseConsmptionsDashboard,
} from '../../store/dashboard/dashboard.actions';
import {
  colorsList,
  ConsumptioncolorsList,
  ConsumptionMinMax,
  LeakmonthsArray,
  monthsArray,
  utilitiesArray,
} from '../../shared/constants/templatesNames';
import { error, log } from 'console';
import { Router } from '@angular/router';
import { billSummary } from '../../shared/constants/enum';
import { meterCommunication_title } from '../../shared/constants/enum';

import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { DashboardService } from '../../core/services/dashboard.service';

import { LoaderService } from '../../core/services/loader.service';
import { NotificationService } from '../../shared/notification.service';
import { ProjectState } from './../../store/Projects/projects.reducer';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  markers: ApexMarkers;
  stroke: ApexStroke;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  tooltip: ApexTooltip;
  fill: ApexFill;
  annotations?: ApexAnnotations;
  colors: any;
};
interface XAxis {
  min: number; // Timestamp in milliseconds
  max: number; // Timestamp in milliseconds
}

interface UpdateOptionsData {
  [key: string]: {
    xaxis: XAxis;
  };
}

@Component({
  selector: 'app-prepaid-admin-dashboard',
  templateUrl: './prepaid-admin-dashboard.component.html',
  styleUrl: './prepaid-admin-dashboard.component.scss',
  providers: [DecimalPipe],
  standalone: false,
})
export class PrepaidAdminDashboardComponent {
  LeakmonthsArray = LeakmonthsArray;
  leakconvertedData: any[] = [];
  convertedData: any[] = [];
  totalNotificationCount: number = 0;
  BillingType = BillingType;
  public seriesVisible = true;
  isLoading: boolean = true;
  isdailyConsumptionChart: boolean = true;
  meterCommunication_title = meterCommunication_title;
  monthlyConsumptionList: any[] = [];
  monthlyConsumptionchartData: any[] = [];
  colors_status = superadmin_graphColors;
  dateRange: boolean = false;
  public style: LineStyle = 'normal';
  public line: LineStyle = 'smooth';
  totalBill = 0;
  datePickerConfig: Partial<BsDatepickerConfig>;
  totalRevenue: number = 0;
  totalPrice = 0;
  @ViewChild('chart', { static: false }) chart?: ChartComponent;
  @ViewChild('leakchart', { static: false }) leakchart?: ChartComponent;
  //@ViewChild('chart', { static: false }) chart: ChartComponent | undefined =undefined;
  public leakchartOptions: ChartOptions = {
    series: [],
    chart: {
      type: 'area',
      height: 250,
    },

    dataLabels: { enabled: false },
    markers: { size: 0 },
    stroke: { curve: 'smooth', width: 2 },
    xaxis: { categories: [] },
    yaxis: { title: { text: '' } },
    tooltip: {},
    colors: ['#008FFB'], // ✅ Add this line
    fill: { type: 'gradient' },
  };
  isSelectMonths = 'Current Month';
  isLeakChartShow: boolean = false;
  devicemonthlyNotificationGraphDataLoding: boolean = true;
  //public chartOptions!: Partial<ChartOptions>;
  public selectedDateRangeLeak: {
    startDate?: string;
    endDate?: string;
  } | null = null;
  public chartOptions: ChartOptions = {
    series: [],
    chart: {
      type: 'area',
      height: 250,
    },
    dataLabels: { enabled: false },
    markers: { size: 0 },
    stroke: { curve: 'smooth', width: 2 },
    xaxis: { categories: [] },
    yaxis: { title: { text: '' } },
    tooltip: {},
    colors: ['#008FFB'], // ✅ Add this line
    fill: { type: 'gradient' },
  };

  // data holders
  public consumptionData: { category: string; value: number }[] = [];
  //public convertedData: [number, number][] = [];
  public consuptiongraphdata: any[] = []; // from your API
  public consuptionSelectedUtilityType: any = { name: 'EB' }; // example
  public selectedDateRange: { startDate?: string; endDate?: string } | null =
    null;
  public consumptionLoader = true;
  public yaxisUnits = '';

  // public chartOptions!: Partial<ChartOptions>; //
  currentUser: any;
  currentUserData: any;
  private flatwiseadminDashboardData$: Subscription = new Subscription();
  selectedRange: any;
  private adminFlatwiseConsumptionDashboardData$: Subscription =
    new Subscription();
  deviceCount: any;

  notificationCountData: any;
  deviceCountGrpahData: any[] = [];
  totalDevicecount: number = 0;
  deviceNotificationGraphDataLoding: boolean = true;
  deviceNotificationStatusGraphNoData: boolean = false;
  totalConsumers: number = 0;
  totalMeterStatus: number = 0;
  consumerData: any[] = [];
  residentialUnitsData: any = [];
  // billSummary: any[] = [];
  billSummary = billSummary;
  prepaidSummary = prepaidSummary;

  projectId: any;
  projectsName: any;
  utlityType: string = '';
  consuptuinUtility = '';
  selectedUtilityConsumption: any;
  meterUtilityType: any;
  meterStatusUtility: any;
  //  consuptionSelectedUtilityType: any;
  topconsuptionSelectedUtilityType: any;
  consuptionSelectedUtility: any;
  topconsuptionSelectedUtility: any;

  consumptionminmaxvalue: any;
  selectedUtilityType: any;
  totalResidentialUnits: number = 0;
  currentWalletBalance: number = 0;
  totalWalletRecharge: number = 0;
  deductedWalletBalance: number = 0;
  sumOfTotalConsumption: number = 0;
  //  consumptionData: any[] = [];
  waterConsumptionData: any[] = [];
  gasConsumptionData: any[] = [];
  electricityConsumptionData: any[] = [];
  months = monthsArray;

  communicationStatusGraphData: any[] = [];
  communicationStatusGraphData_temp: any = [];
  communicationMeterStatusGraphData: any[] = [];
  utilities = utilitiesArray;
  categories: any[] = [];
  consuptionCategories: any[] = [];
  consumptionUtlity: any[] = [];
  // selectedDateRange: { startDate: string; endDate: string } | null = null;
  watercategories: any[] = [];
  gascategories: any[] = [];
  electricitycategories: any[] = [];
  Water: any[] = [];
  Gas: any = [];
  Electricity: any = [];
  meterCommunicationStatus: boolean = false;
  meterCommunicationList: any[] = [];
  // consuptiongraphdata: any = [];
  colors = superadmin_graphColors;
  topConsumptionElectricity: any = [];
  topConsumptionList: any[] = [];
  topconsumptionData: any[] = [];
  topConsumptionWatercategories: any = [];
  topConsumptionGascategories: any = [];
  topConsumptionElectricitycategories: any = [];
  colorslist = ConsumptioncolorsList;
  topConsumptioncategories: any = [];
  isWalletEnabled: boolean = false;
  projectName: any;
  public deviceNotificationGraphdata: { category: string; value: number }[] =
    [];
  monthlydeviceNotificationGraphdata: any[] = [];
  billingType: any;
  projectUtlityList: any[] = [];
  projectFilterUtlitys: any[] = [];
  communicationStatusUtilities: any[] = [];
  projectStartDate: any;
  isDashboardAdmin: boolean = false;
  maxminlist = ConsumptionMinMax;
  // consumptionLoader: boolean = true;
   public filterUtilitiesForDashboard(utilities: any[] | undefined): any[] {
    if (!utilities || !Array.isArray(utilities)) return [];
    return utilities.filter((u: any) => {
      const name = u?.name ?? u?.Name ?? '';
      return name.toString().trim().toLowerCase() !== 'ev';
    });
  }
  billSummaryLoader: boolean = true;
  prepiadSummaryLoader: boolean = true;
  topconsumptionLoader: boolean = true;
  monthlyConsumptionLoader: boolean = false;
  billingInitiatedOn: any;

  constructor(
    private router: Router,
    private store: Store,
    private decimalPipe: DecimalPipe,
    private sharedService: SharedService,
    private dashboardService: DashboardService,
    private loaderService: LoaderService,
    private notificationService: NotificationService
  ) {
    const currentUserString = localStorage.getItem('currentUser');
    this.currentUserData = JSON.parse(currentUserString ?? '');
 this.projectUtlityList = this.filterUtilitiesForDashboard(
  this.currentUserData?.projectUtilities
);

this.projectFilterUtlitys = this.filterUtilitiesForDashboard(
  this.currentUserData?.projectUtilities
);

this.communicationStatusUtilities = this.filterUtilitiesForDashboard(
  this.projectUtlityList
);

    const containsElectricityOrTriSource = this.projectFilterUtlitys.some(
      (item: any) => item.name === 'Electricity' || item.name === 'TriSource'
    );
    // Filter out 'Electricity' and 'TriSource'
    this.projectFilterUtlitys = this.projectFilterUtlitys.filter(
      (item: any) => item.name !== 'Electricity' && item.name !== 'TriSource'
    );
    // Add EB and DG only once if either was present
    if (containsElectricityOrTriSource) {
      this.projectFilterUtlitys.push(
        { id: 'EB', name: 'EB' },
        { id: 'DG', name: 'DG' }
      );
    }
    /*  console.log(
      'his.projectUtlityList------------>',
      this.projectFilterUtlitys
    ); */
    this.isWalletEnabled = this.currentUserData?.project?.isWalletEnabled;
    this.projectStartDate = this.currentUserData?.project?.startDate;
    this.billingInitiatedOn = this.currentUserData?.project?.billingInitiatedOn;
    //console.log(this.isWalletEnabled)
    const today = new Date();
    //const lastMonth = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const firstDayOfCurrentMonth = new Date(
      today.getFullYear(),
      today.getMonth(),
      1
    );
    const minDate = new Date(firstDayOfCurrentMonth);
    minDate.setMonth(today.getMonth() - 1);
    //lastMonth.setMonth(today.getMonth() - 1);
    // console.log(this.projectUtlityList);
    this.currentUserData = JSON.parse(currentUserString ?? '');
     const currentRole = this.normalizeRole(
      this.currentUserData?.currentUserRoleDetails?.role
    );
    this.isDashboardAdmin =
        currentRole === this.normalizeRole(Roles.DASHBOARDADMIN);
    if (this.currentUserData.project !== null) {
      this.projectId = this.currentUserData.project.id;
      this.projectName = this.currentUserData.project.name;
      this.billingType = this.currentUserData?.project?.billingType

    }

    this.datePickerConfig = Object.assign(
      {},
      {
        dateInputFormat: 'YYYY-MM-DD', // Customize as needed
        showWeekNumbers: false,
        isAnimated: true,
        containerClass: 'theme-dark-blue',
        minDate: minDate, // Set minimum date to 6 months ago
        maxDate: yesterday, // Set maximum date to yesterday
      }
    );
    this.getStoreInfo();
  }

  getStoreInfo() {
    // console.log('store');
    if (!this.isDashboardAdmin) {
      this.leakNotificationselectionChange('Current Month');
    }
    this.selectionChange('Current Month');
    this.flatwiseadminDashboardData$ = this.store
      .pipe(select(getadmindashboardResponse))
      .subscribe({
        next: (data) => {
          if (data) {
            this.currentWalletBalance =
              data.data.walletData.currentWallteBalance;
            this.totalWalletRecharge = data.data.walletData.totalWalletRecharge;
            this.deductedWalletBalance =
              data.data.walletData.deductedWalletBalance;

            this.meterCommunicationStatus =
              data.data.meterConfigCounts == null ? false : true;
            this.meterCommunicationList = data.data.meterConfigCounts ?? {};
            /*  this.meterCommunicationList =
              data.data.meterConfigCounts !== null
                ? data.data.meterConfigCounts
                : null; */

            if (Object.keys(data.data.prepaidBiilsData).length > 0) {
              this.prepaidSummary = this.prepaidSummary.map((item: any) => {
                if (item.label === 'Amount to be Collected') {
                  return {
                    ...item,
                    value: data.data.prepaidBiilsData.amountToBeCollected,
                    // amount: response.data.prepaidBiilsData.amountToBeCollected // Optionally, if you want to update the amount
                  };
                } else if (item.label === 'Revenue') {
                  return {
                    ...item,
                    value: data.data.prepaidBiilsData?.totalRevenue,
                    // amount: response.data.prepaidSummary?.unpaidBillsAmount // Optionally, if you want to update the amount
                  };
                } else if (item.label === 'Total Bills') {
                  return {
                    ...item,
                    value: data.data.prepaidBiilsData.totalBillsCount,
                    amount: data.data.prepaidBiilsData.totalBillsAmount, // Optionally, if you want to update the amount
                  };
                }
                return item; // In case of no matching label, return the item unchanged
              });
              if (this.prepaidSummary.length > 0) {
                this.prepiadSummaryLoader = false;
              }
              //console.log(this.prepaidSummary);
            } else {
              this.loaderService.setLoading(false);
              this.prepaidSummary = [];
              this.prepiadSummaryLoader = false;
            }
            setTimeout(() => {
              if (Object.keys(data.data.residentialUnitData).length > 0) {
                this.getResidentialUnitData(data.data.residentialUnitData);
              }
              // console.log(this.meterCommunicationList);
              // console.log(this.projectUtlityList);
              if (Object.keys(this.meterCommunicationList).length > 0) {
                this.metreSttausData(
                  this.meterCommunicationList,
                  this.projectUtlityList[0].name
                );
                this.communicationStatusData(
                  this.meterCommunicationList,
                  this.projectUtlityList[0].name
                );
              } else {
                this.communicationMeterStatusGraphData = [];
                this.communicationStatusGraphData = [];
              }

              // console.log(data.data.ownerTenentCount);
              if (Object.keys(data.data.ownerTenentCount).length > 0) {
                this.listOfConsumers(data.data.ownerTenentCount);
              } else {
                this.consumerData = [];
              }
            }, 500);
          }
        },
        error(err) {
          console.log(err);
        },
      });
  }

  openCalendar() {
    // Trigger the click event on the input field to open the datepicker
    const dateInput = document.querySelector('.form-control.date');
    dateInput?.dispatchEvent(new Event('click'));
  }
  selectDates(event: any) {
    //console.log(event);
    if (event == undefined) {
      this.billdate = [];
    }
  }
  billdate: any = [];
  formatDateRange(dateRange: (Date | null)[]): string {
    if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
      const startDate = formatDate(dateRange[0], 'dd/MM/YYYY', 'en-US');
      const endDate = formatDate(dateRange[1], 'dd/MM/YYYY', 'en-US');
      return `${startDate} to ${endDate}`;
    }
    return ''; // Return empty string if the date range is not valid
  }

  InitialluAssignedvalues() {
    this.consuptuinUtility = 'Water';
    this.selectedRange = 'Current Month';
    this.selectedUtilityConsumption = this.projectUtlityList[0].id;
    this.consuptionSelectedUtilityType = this.projectFilterUtlitys[0];
    this.topconsuptionSelectedUtilityType = this.projectFilterUtlitys[0];
    // console.log(this.topconsuptionSelectedUtilityType);
    // console.log(this.topconsuptionSelectedUtilityType);
    this.consuptionSelectedUtility = this.projectFilterUtlitys[0].id;
    this.topconsuptionSelectedUtility = this.projectFilterUtlitys[0].id;
    this.meterUtilityType = this.projectUtlityList[0].id;
    this.meterStatusUtility = this.projectUtlityList[0].id;
    this.consumptionminmaxvalue = this.maxminlist[0].id;
    this.selectedUtilityType = this.projectUtlityList[0];
    this.selectedmeterCommunicationutility = this.projectUtlityList[0].name;
  }

  ngOnInit(): void {
    this.notificationService.emitNotificationUpdate();
    this.InitialluAssignedvalues();
    this.initilApis();
    this.getDashboardData();
  }
  initilApis() {
    if (this.isDashboardAdmin) {
      this.deviceCountGrpahData = [];
      this.deviceNotificationGraphdata = [];
      this.monthlydeviceNotificationGraphdata = [];
      this.totalNotificationCount = 0;
      return;
    }
    // this.deviceNotificationGraphDataLoding = true;
    this.dashboardService.getAdminDeviceCountData(this.projectId).subscribe({
      next: (data) => {
        console.log(data);
        if (data.statusCode == 200) {
            this.deviceCount = data.data ?? {};
          console.log(data);
         this.totalDevicecount = this.deviceCount?.totalDevices ?? 0;
          console.log(this.deviceCount);
          const deviceCountGrpahData = [
            {
              name: 'Only GSM Connected',
              value: this.deviceCount?.gsmConnectedCount ?? 0,
              color: this.colors[0],
            },
            {
              name: 'Both GSM and Wifi Connected',
              value: this.deviceCount?.gsmWifiConnectedCount ?? 0,

              color: this.colors[1],
            },
            {
              name: 'Only WIFI Connected',
              value: this.deviceCount?.wifiConnectedCount ?? 0,

              color: this.colors[2],
            },
            {
              name: 'Disconnected',
              value: this.deviceCount?.disconnectedCount ?? 0,

              color: this.colors[3],
            },
          ];
            this.deviceCountGrpahData =
            this.totalDevicecount > 0 ? deviceCountGrpahData : [];
          console.log(this.deviceCountGrpahData );
        
        } else {
          this.deviceCountGrpahData = [];
        }
      },
      error: (err) => {
        console.log(err);
        this.loaderService.setLoading(false);

        // Check if backend returned an error.message
        const errorMsg =
          err.error?.message || 'Something went wrong. Please try again later.';

        this.sharedService.showMessageDialog(
          errorMsg,
          '',
          SweetAlertIcon.ERROR
        );
      },
    });
  }
  LeakDetectionIdentifier(dateRange: any) {
    this.loaderService.setLoading(true);

    let request = {
      startDate: dateRange?.startDate,
      endDate: dateRange?.endDate,
      ProjectIds: [this.projectId],
    };
    console.log(request);
    this.dashboardService.getDeviceNotificationCountData(request).subscribe({
      next: (res) => {
        console.log(res);
        if (res.statusCode == 200) {
          console.log(res);
          this.loaderService.setLoading(false);
          this.notificationCountData = res.data;
          this.deviceNotificationData(this.notificationCountData);
        } else {
          this.deviceNotificationStatusGraphNoData = true;
          this.deviceNotificationGraphDataLoding = false
        }
      },
      error: (err) => {
        this.deviceNotificationGraphDataLoding = false;
        this.deviceNotificationStatusGraphNoData = true;
        this.deviceNotificationGraphdata = [];
        console.log(err);
        this.loaderService.setLoading(false);

        // Check if backend returned an error.message
        const errorMsg =
          err.error?.message || 'Something went wrong. Please try again later.';

        this.sharedService.showMessageDialog(
          errorMsg,
          '',
          SweetAlertIcon.ERROR
        );
      },
    });
  }
  deviceNotificationData(data: any) {
    console.log(data);
    this.leakNotifocationinitChart();
    console.log(this.isSelectMonths);
    if (
      this.isSelectMonths == 'Last Three Months' ||
      this.isSelectMonths == 'Last Six Months'
    ) {
      this.isLeakChartShow = false;
      this.devicemonthlyNotificationGraphDataLoding = true;

      const monthlyWiseNotificationdata =
        this.leakconvertToMonthlyNotifications({
          notificationTotalCount: data.notificationTotalCount,
          dayWiseNotificationCount: data.dayWiseNotificationCount,
        });
      console.log(monthlyWiseNotificationdata);
      if (monthlyWiseNotificationdata.length > 0) {
        this.monthlyLeakNotificationChart(monthlyWiseNotificationdata);
      }
    } else {
      this.deviceNotificationGraphDataLoding = true;
      this.devicemonthlyNotificationGraphDataLoding = false;
      this.isLeakChartShow = true;
      this.leakNotificationloadChart();
    }
  }

  getDashboardData() {
    this.store.dispatch(getAdminDashboard({ ProjectId: this.projectId }));
  }
  ngOnDestroy() {
    this.flatwiseadminDashboardData$.unsubscribe();
    this.adminFlatwiseConsumptionDashboardData$.unsubscribe(); // Or set it to [] if you prefer an empty array
  }
  refreshDashboard() {
    this.InitialluAssignedvalues();
    this.getDashboardData();
    this.selectionChange('Current Month');
  }

  getflatwiseConsuptiondata() {
    this.monthlyConsumptionLoader = true;
    this.topconsumptionLoader = true;
    this.consumptionLoader = true;
    this.billSummaryLoader = true;
    //this.prepiadSummaryLoader = true;

    // this.loaderService.setLoading(true)
    let request = {
      projectId: this.projectId,
      startDate: this.selectedDateRange?.startDate,
      endDate: this.selectedDateRange?.endDate,
    };
    this.dashboardService
      .getAdminFaltwiseConsumptionDashboardData(request)
      .subscribe({
        next: (response) => {
          if (response && response.statusCode == 200) {
            this.topConsumptionList = response.data.consumptionByFlat;
            /*   console.log(
              'this.prepaidSummary------------',
              this.topconsuptionSelectedUtility
            ); */
            if (Object.keys(response.data.billSummaryData).length > 0) {
              // this.billSummaryData(response.data.billSummaryData);
              this.billSummary = this.billSummary.map((item: any) => {
                if (item.label === 'Paid Bills') {
                  return {
                    ...item,
                    value: response.data.billSummaryData.paidBillsCount,
                    amount: response.data.billSummaryData.paidBillsAmount, // Optionally, if you want to update the amount
                  };
                } else if (item.label === 'Unpaid Bills') {
                  return {
                    ...item,
                    value: response.data.billSummaryData.unpaidBillsCount,
                    amount: response.data.billSummaryData.unpaidBillsAmount, // Optionally, if you want to update the amount
                  };
                } else if (item.label === 'Total Bills') {
                  return {
                    ...item,
                    value: response.data.billSummaryData.totalBillCount,
                    amount: response.data.billSummaryData.totalBillAmount, // Optionally, if you want to update the amount
                  };
                }
                return item; // In case of no matching label, return the item unchanged
              });
              if (this.billSummary.length > 0) {
                this.billSummaryLoader = false;
              }
              // console.log(this.billSummary);
            } else {
              this.loaderService.setLoading(false);
              this.billSummary = [];
              this.billSummaryLoader = false;
            }
            if (this.topConsumptionList.length > 0) {
              this.flatwiseConsumptionData();

              /* this.topconsuptionSelectedUtility =
                this.projectFilterUtlitys[0].id; */
            } else {
              this.loaderService.setLoading(false);
              this.topconsumptionData = [];
              this.topconsumptionLoader = false;
            }
          } else {
            this.loaderService.setLoading(false);
            this.topconsumptionData = [];
          }
        },
        error: (err) => {
          console.log(err);
          this.topconsumptionLoader = false;
        },
      });
    // this.loaderService.setLoading(true)
    this.dashboardService.getAdminConsumptionData(request).subscribe({
      next: (response) => {
        this.loaderService.setLoading(false);
        if (response && response.statusCode == 200) {
          this.consuptiongraphdata = [];
          // console.log(this.consumptionLoader)
          //  console.log('res=======>', response.data);
          this.consuptiongraphdata = response.data;

          // this.consuptionSelectedUtility = this.projectFilterUtlitys[0].id;
          if (this.consuptiongraphdata && this.consuptiongraphdata.length > 0) {
            //  this.sumOfTotalConsumption = this.consuptiongraphdata[0]?.sumOfTotalConsumption;
            /* console.log(
              'Last Three Months------------>',
              this.consuptionSelectedUtility
            ); */

            if (
              this.selectedRange == 'Last Three Months' ||
              this.selectedRange == 'Last Six Months'
            ) {
              this.isdailyConsumptionChart = false;

              this.monthlyConsumptionList = this.convertToMonthlyConsumption(
                this.consuptiongraphdata
              );
              //   console.log(this.monthlyConsumptionList);
              if (this.monthlyConsumptionList.length > 0) {
                this.monthlyConsuptionChart();
                this.consumptionLoader = false;
              } else {
                this.monthlyConsumptionLoader = false;
              }
            } else {
              // console.log(this.selectedRange);
              this.isdailyConsumptionChart = true;
              this.initChart();
              this.monthlyConsumptionLoader = false;
              // console.log(this.consuptionSelectedUtility);
              this.loadConsumptionChart();
            }
          } else {
            this.isdailyConsumptionChart = true;
            //  console.log(this.consumptionLoader);
            this.consuptiongraphdata = [];
            this.consumptionData = [];
            // this.initChart()

            this.consumptionLoader = false;
            //s console.log(this.consumptionLoader)
          }
        }
      },
      error: (err) => {
        console.log(err);
        this.consumptionLoader = false;
      },
    });
  }
  monthlyLeakNotificationChart(data: any) {
    console.log(data);
    this.devicemonthlyNotificationGraphDataLoding = true;
    this.monthlydeviceNotificationGraphdata = [];
      if (!Array.isArray(data) || !data[0]?.monthlyWiseNotificationCount?.length) {
      this.totalNotificationCount = 0;
      this.devicemonthlyNotificationGraphDataLoding = false;
      return;
    }
    this.totalNotificationCount = this.getNotificationTotalCount(data[0]);
    data[0].monthlyWiseNotificationCount.forEach((res: any, index: number) => {
      this.monthlydeviceNotificationGraphdata.push({
        category: res.monthName,
         value: Number(res.totalCount ?? 0),
        colorString: this.colors[index],
      });
    });

    if (this.monthlydeviceNotificationGraphdata.length > 0) {
      this.devicemonthlyNotificationGraphDataLoding = false;
    }
  }
  monthlyConsuptionChart() {
    this.monthlyConsumptionLoader = true;
    this.monthlyConsumptionchartData = [];

    // console.log(this.consuptionSelectedUtilityType?.name);
    const utilityType = this.monthlyConsumptionList.find(
      (utility: any) =>
        utility.utilityMasterName === this.consuptionSelectedUtilityType.name
    );
    /*  console.log(
      'utilityType -- test 123--------------------------------->,',
      utilityType
    ); */
    // console.log('this.monthlyConsumptionList,', this.monthlyConsumptionList);
    // this.monthlyConsumptionList.forEach((item: any) => {

    if (utilityType) {
      this.sumOfTotalConsumption = utilityType.sumOfTotalConsumption;
      // Iterate over the monthlyConsumptions array of the itemutility
      utilityType.monthlyConsumptions.forEach((res: any, index: number) => {
        this.monthlyConsumptionchartData.push({
          category: res.monthName,
          value: res.totalConsumptionForUtility.toFixed(2),
          colorString: this.colors[index],
        });
      });
    } else {
      this.monthlyConsumptionchartData = [];
      this.monthlyConsumptionLoader = false;
    }
    //});
    if (this.monthlyConsumptionchartData.length > 0) {
      this.monthlyConsumptionLoader = false;
    }

    // console.log('Final data', this.monthlyConsumptionchartData);
  }
  leakconvertToMonthlyNotifications(data: any): any[] {
    // wrap into array if single object
    const items = Array.isArray(data) ? data : [data];

    return items.map((item: any) => {
      const totalNotificationCount = item.notificationTotalCount;

      const dailyData = item.dayWiseNotificationCount;
      if (!dailyData) return [];

      // Group by month
      const monthlyData = Object.keys(dailyData).reduce(
        (acc: any, date: string) => {
          const [year, month] = date.split('-');
          const monthKey = `${year}-${month}`;

          if (!acc[monthKey]) {
            acc[monthKey] = {
              year: Number(year),
              month: Number(month),
              monthName: new Date(`${year}-${month}-01`).toLocaleString(
                'default',
                {
                  month: 'long',
                }
              ),
              totalCount: 0,
            };
          }

          acc[monthKey].totalCount += dailyData[date];
          return acc;
        },
        {}
      );

      return {
        totalNotificationCount,
        monthlyWiseNotificationCount: Object.values(monthlyData),
      };
    });
  }
  convertToMonthlyConsumption(data: UtilityData[]): any[] {
    return data.map((item) => {
      // Get the utility name

      const utilityName = item.utilityMasterName;
      const sumOfTotalConsumption = item.sumOfTotalConsumption;
      // Get the daily consumption data
      const dailyData = item.totalConsumptionByDay;

      // Group the data by month and calculate total consumption for each month
      const monthlyData = Object.keys(dailyData).reduce(
        (acc: { [key: string]: MonthlyConsumption }, date: string) => {
          const [year, month] = date.split('-');
          const monthKey = `${year}-${month}`; // Grouping by year and month

          // Initialize the accumulator if it doesn't exist for the month
          if (!acc[monthKey]) {
            acc[monthKey] = {
              year: parseInt(year),
              month: parseInt(month),
              monthName: new Date(`${year}-${month}`).toLocaleString(
                'default',
                { month: 'long' }
              ),
              totalConsumptionForUtility: 0,
            };
          }

          // Add the daily consumption to the total for the respective month
          acc[monthKey].totalConsumptionForUtility += dailyData[date];

          return acc;
        },
        {}
      );

      // Convert the grouped data into an array of monthly consumption objects
      const monthlyConsumptions = Object.values(monthlyData);

      // Return the transformed data
      return {
        sumOfTotalConsumption: sumOfTotalConsumption,
        utilityMasterName: utilityName,
        monthlyConsumptions,
      };
    });
  }

  goToWallet() {
    if (this.shouldBlockDashboardAdminNavigation()) {
      return;
    }
    // this.router.navigate(['/wallet'], { state: { consumerData: 'data' }, });
    this.router.navigate(['/wallet']);
  }
  leakNotificationloadChart() {
    this.deviceNotificationGraphdata = [];
   const consumptionData =
      this.notificationCountData?.dayWiseNotificationCount ?? {};
    this.totalNotificationCount = this.getNotificationTotalCount(
      this.notificationCountData
    );
    console.log(
      ' this.sumOfTotalConsumption--------->',
      this.totalNotificationCount
    );

    for (const date in consumptionData) {
      // this.sumOfTotalConsumption = this.consuptiongraphdata[0].sumOfTotalConsumption
      if (consumptionData.hasOwnProperty(date)) {
        const value = consumptionData[date];
        this.deviceNotificationGraphdata.push({
          category: date,
          value: value,
        });
        // console.log(`category: "${date}", value: ${value}`);
      }
    }
 const convertedData = this.deviceNotificationGraphdata
      .map((item) => this.toChartPoint(item.category, item.value))
      .filter((item): item is [number, number] => item !== null);
    console.log(this.convertedData);
    console.log('Converted Data:', this.leakchartOptions.series);
    console.log(this.leakchartOptions);
    
    if (convertedData.length == 0) {
      this.leakconvertedData = [];
      this.deviceNotificationGraphdata = [];
      this.deviceNotificationGraphDataLoding = false;
      return;
    }

    if (
      this.leakchartOptions?.series &&
      this.leakchartOptions.series[0]?.data
    ) {
      this.leakchartOptions.series[0].data = [];

      //   console.log('convertedData test', convertedData);

      this.leakchartOptions.series[0].data = convertedData;
      this.leakconvertedData = convertedData;

      this.deviceNotificationGraphDataLoding = false;
      console.log(this.leakconvertedData);
      this.leakNotifocationinitChart();
    }

    this.leakupdateOptions(this.isSelectMonths as keyof UpdateOptionsData);
    this.leakchart?.updateOptions(this.leakchartOptions, false, true, true); // Refresh chart
    console.log('convertedData test', this.deviceNotificationGraphDataLoding);
    setTimeout(() => {
      this.deviceNotificationGraphDataLoding = false;
    }, 200);
  } public leakupdateOptions(option: keyof UpdateOptionsData): void {
    const optionData =
      this.updateOptionsData[option as keyof typeof this.updateOptionsData];
    if (optionData) {
      this.leakchart?.updateOptions(optionData, false, true, true);
    } else {
      console.log(`Option for '${option}' is undefined.`);
      // Handle undefined option case
    }
  }

  leakNotifocationinitChart(): void {
    const startDate = this.selectedDateRangeLeak?.startDate
      ? new Date(this.selectedDateRangeLeak.startDate)
      : null;
    const dateDiff =
      startDate && this.selectedDateRangeLeak?.endDate
        ? new Date(this.selectedDateRangeLeak.endDate).getTime() -
        startDate.getTime()
        : 0;

    // Choose the date format based on the date difference (2 months in milliseconds)
    const dateFormat =
      dateDiff > 2 * 24 * 60 * 60 * 1000 ? 'dd MMM' : 'dd MMM HH:mm';
    //  console.log(dateFormat)

    this.leakchartOptions = {
      series: [
        {
          name: '',
          data: this.leakconvertedData,
        },
      ],
      chart: {
        type: 'area',
        height: 250,
        toolbar: { show: false },
        zoom: { enabled: false },
        events: {
          // mounted: (chart: any) => chart.windowResizeHandler(),
          dataPointMouseEnter: (event, chartContext, config) =>
            chartContext.chart.showTooltip(config.dataPointIndex),
          click: (event, chartContext, config) => {
            const dataPointIndex = config.dataPointIndex;
            if (dataPointIndex !== undefined) {
              this.handleDataPointClick(config.seriesIndex, dataPointIndex);
            }
          },
        },
      },
      colors: ['#008FFB'], // ✅ Add this line

      dataLabels: { enabled: false },
      markers: { size: 0 },

      // ✅ Added stroke (Fix)
      stroke: {
        curve: 'smooth',
        width: 2,
      },

      xaxis: {
        type: 'datetime',
        min: this.toTimestamp(this.selectedDateRangeLeak?.startDate),
        max: this.toTimestamp(this.selectedDateRangeLeak?.endDate),
        tickAmount: 3,
        title: { text: 'Dates' },
        labels: { format: dateFormat },
        tooltip: { enabled: false },
        crosshairs: { show: false },
      },

      yaxis: {
        title: { text: 'Count' },
      },

      tooltip: {
        x: { format: 'dd MMM yyyy' },
        y: { formatter: (value) => `${value}` },
      },

      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          stops: [0, 100],
        },
      },
    };
  }
  last3monthdDateRange() {
    const projectStart = new Date(this.currentUserData?.project?.startDate);
    console.log('dateon', projectStart);
    const today = new Date();

    // Calculate date 3 months before today
    const threeMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());

    let startDate: Date;
    let endDate: Date = today;

    // If project started within last 3 months → use project start date
    if (projectStart > threeMonthsAgo) {
      startDate = projectStart;
    }
    else {
      // Otherwise use "3 months back from today"
      startDate = threeMonthsAgo;
    }

    // Format function
    const format = (date: Date) =>
      `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;

    const result = {
      startDate: format(startDate),
      endDate: format(endDate)
    };

    console.log("Final Range:", result);
    return result;
  }

  last3monthdDateRange_old() {
    const ProjectState = new Date(this.currentUserData?.project?.startDate);
    console.log('dateon', ProjectState);
    const today = new Date();

    // END = Last day of previous month
    const endDate = new Date(today.getFullYear(), today.getMonth(), 0);

    // START = First day of 3 months ago (from last month)
    const startDate = new Date(
      endDate.getFullYear(),
      endDate.getMonth() - 2,
      1
    );

    // Formatter
    const toDateString = (date: Date): string =>
      `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;

    // OUTPUT
    const fromDate = toDateString(startDate);
    const toDate = toDateString(endDate);

    console.log(fromDate, toDate);

    let daterange = { startDate: fromDate, endDate: toDate }

    return daterange;
  }
  gotoWalletHistoryreport() {
    if (this.shouldBlockDashboardAdminNavigation()) {
      return;
    }
    /*  const today = new Date();
 
     // Get last day of previous month (local)
     const endDate = new Date(today.getFullYear(), today.getMonth(), 0); // e.g., June 30
 
     // Get first day of 6 months ago (local)
     const startDate = new Date(
       endDate.getFullYear(),
       endDate.getMonth() - 5,
       1
     ); // e.g., Jan 1
 
     const toDateString = (date: Date): string =>
       `${date.getFullYear()}-${(date.getMonth() + 1)
         .toString()
         .padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
 
     this.selectedDateRange = {
       startDate: toDateString(startDate),
       endDate: toDateString(today),
     }; */

    let daterange = this.last3monthdDateRange()

    console.log(daterange);
    // let daterange = { startDate: fromDate, endDate:toDate }

    let request = {
      type: 'Total Wallet History',
      projectStartDate: daterange,

      //  projectStartDate: this.projectStartDate,
    };

    this.router.navigate(['/reports'], {
      state: { consumptionItem: request },
    });
  }
  goToWalletReport() {
    if (this.shouldBlockDashboardAdminNavigation()) {
      return;
    }
    const today = new Date();

    // Get last day of previous month (local)
    const endDate = new Date(today.getFullYear(), today.getMonth(), 0); // e.g., June 30

    // Get first day of 6 months ago (local)
    const startDate = new Date(
      endDate.getFullYear(),
      endDate.getMonth() - 5,
      1
    ); // e.g., Jan 1

    const toDateString = (date: Date): string =>
      `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;

    this.selectedDateRange = {
      startDate: toDateString(startDate),
      endDate: toDateString(today),
    };

    //  console.log(this.selectedDateRange);
    let request = {
      type: 'Total Wallet Recharge',
      projectStartDate: this.selectedDateRange,
    };

    this.router.navigate(['/reports'], {
      state: { consumptionItem: request },
    });

    // this.router.navigate(['/maintenance'], {
    //   state: { consumptionItem: request },
    // });
  }

  /* // Original date range
const dateRange = [new Date('2025-02-04T09:24:59.000Z'), new Date('2025-02-04T09:24:59.000Z')];

// Set start date to 00:00:00.000Z
const startDate = new Date(dateRange[0]);
startDate.setUTCHours(0, 0, 0, 0);  // Setting the time to 00:00:00.000Z

// Set end date to 23:59:59.999Z
const endDate = new Date(dateRange[1]);
endDate.setUTCHours(23, 59, 59, 999);  // Setting the time to 23:59:59.999Z

// Output the modified start and end dates
console.log('Start Date:', startDate.toISOString());
console.log('End Date:', endDate.toISOString());
 */
  clearDate() {
    this.filterProjectBillDates = null; // Clear the selected date
    this.selectionChange('Current Month');
    this.selectedRange = 'Current Month';
  }
  onDateRangeSelected(dateRange: (Date | undefined)[] | undefined): void {
    this.flatwiseadminDashboardData$.unsubscribe();
    if (dateRange && dateRange.length === 2 && dateRange[0] && dateRange[1]) {
      // console.log(dateRange);
      // const startDate = dateRange[0];
      // const endDate = dateRange[1];

      // Set start date to 00:00:00.000Z
      const startDate = new Date(dateRange[0]);
      startDate.setHours(0, 0, 0, 0); // Setting the time to 00:00:00.000Z

      // Set end date to 23:59:59.999Z
      const endDate = new Date(dateRange[1]);
      // endDate.setUTCHours(23, 59, 59, 999);
      endDate.setHours(23, 59, 59, 999); // Setting the time to 23:59:59.999Z
      this.selectedDateRange = {
        startDate: formatDate(
          startDate,
          "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
          'en-US'
        ),
        endDate: formatDate(endDate, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'", 'en-US'),
      };
      // console.log(this.selectedDateRange)
      this.topconsumptionData = [];
      this.topConsumptionElectricity = [];

      this.getflatwiseConsuptiondata();
    }
  }

  public updateOptionsData = {
    'Current Month': {
      xaxis: {
        /*  min: new Date("28 Jan 2013").getTime(),
         max: new Date("27 Feb 2013").getTime(), */
        min: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          1
        ).getTime(),
        max: new Date().getTime(),
      },
    },
    'Last Month': {
      xaxis: {
        min: new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 1,
          1
        ).getTime(),
        max: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          0
        ).getTime(),
      },
    },
    'Last Three Months': {
      xaxis: {
        min: new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 2,
          1
        ).getTime(),
        max: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          0
        ).getTime(),
      },
    },
    'Last Six Months': {
      xaxis: {
        min: new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 5,
          1
        ).getTime(),
        max: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          0
        ).getTime(),
      },
    },
  };

  selectionChange(event: any) {
    // this.loaderService.setLoading(true);
    if (event != undefined) {
      this.topConsumptionWatercategories = [];
      this.topConsumptionElectricitycategories = [];
      this.topConsumptionGascategories = [];
      // this.consuptionSelectedUtility
      // this.consuptionSelectedUtilityType = this.projectUtlityList[0];
      // this.topconsuptionSelectedUtilityType = this.projectUtlityList[0];
      const selectedOption = event;
      this.dateRange = false;
      const now = new Date();
      let startDate: Date;
      let endDate: Date = now;

      switch (selectedOption) {
        case 'Current Month':
          startDate = new Date(now.getFullYear(), now.getMonth(), 1);
          // Yesterday
          endDate = new Date(now);
          /*  endDate.setDate(endDate.getDate() - 1);
           endDate.setHours(23, 59, 59, 999); */
          endDate = now; // Current date of the current month
          endDate.setHours(23, 59, 59, 999);
          break;
        case 'Last Month':
          startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1); // First day of last month
          endDate = new Date(now.getFullYear(), now.getMonth(), 0); // Last day of last month
          endDate.setHours(23, 59, 59, 999); //
          break;
        case 'Last Three Months':
          startDate = new Date(now.getFullYear(), now.getMonth() - 3, 1);
          endDate = new Date(now.getFullYear(), now.getMonth(), 0); // Last day of the previous month
          endDate.setHours(23, 59, 59, 999); //
          break;
        case 'Last Six Months':
          startDate = new Date(now.getFullYear(), now.getMonth() - 6, 1);
          endDate = new Date(now.getFullYear(), now.getMonth(), 0); // Last day of the previous month
          endDate.setHours(23, 59, 59, 999); //
          break;

        case 'Custom Range':
          this.dateRange = true;
          this.loaderService.setLoading(false);

          // Implement custom range logic here
          return;
        default:
          startDate = now;
          endDate = now;
      }

      // Format dates to UTC
      this.selectedDateRange = {
        startDate: formatDate(
          startDate,
          "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
          'en-US'
        ),
        endDate: formatDate(endDate, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'", 'en-US'),
      };

      this.getflatwiseConsuptiondata();
      //  console.log(this.selectedDateRange);
    } else {
      this.loaderService.setLoading(false);
      this.billSummary = [];
      this.selectedDateRange = null;
      this.dateRange = false;
      this.topconsumptionData = [];
      this.consumptionData = [];
    }
  }
  leakNotificationselectionChange(event: any) {
    console.log(event);
    const selectedOption = event;
    this.isSelectMonths = selectedOption;
    this.dateRange = false;
    const now = new Date();
    let startDate: Date;
    let endDate: Date = now;
    this.filterProjectBillDates = null;
    switch (selectedOption) {
      case 'Current Month':
        startDate = new Date(now.getFullYear(), now.getMonth(), 1);
        endDate = new Date(now);
        endDate.setHours(23, 59, 59, 999);
        break;
      case 'Last Month':
        startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1); // First day of last month
        endDate = new Date(now.getFullYear(), now.getMonth(), 0);
        endDate.setHours(23, 59, 59, 999); // Last day of last month
        break;
      case 'Last Three Months':
        startDate = new Date(now.getFullYear(), now.getMonth() - 3, 1);
        endDate = new Date(now.getFullYear(), now.getMonth(), 0);
        endDate.setHours(23, 59, 59, 999); // Last day of the previous month
        break;
      case 'Last Six Months':
        startDate = new Date(now.getFullYear(), now.getMonth() - 6, 1);
        endDate = new Date(now.getFullYear(), now.getMonth(), 0);
        endDate.setHours(23, 59, 59, 999); // Last day of the previous month
        break;
      case 'Custom Range':
        this.dateRange = true;
        // Implement custom range logic here
        return;
      default:
        startDate = now;
        endDate = now;
    }

    this.selectedDateRangeLeak = {
      //for Leak Detection Identifier
      startDate: formatDate(startDate, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'", 'en-US'),
      endDate: formatDate(endDate, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'", 'en-US'),
    };
    this.LeakDetectionIdentifier(this.selectedDateRangeLeak);
  }

  private getNotificationTotalCount(data: any): number {
    const apiTotal = Number(data?.notificationTotalCount ?? 0);
    const dayWiseNotificationCount = data?.dayWiseNotificationCount ?? {};
    const calculatedTotal = Object.values(dayWiseNotificationCount).reduce(
      (sum: number, count: any) => sum + Number(count ?? 0),
      0
    );

    return apiTotal > 0 ? apiTotal : calculatedTotal;
  }

  filterProjectBillDates: any;
  labelEllipsisTemplate = (e: any) => {
    const fullText = e.text ?? '';

    // Split the text into flatNo and tower parts by searching for the last '(tower: ...)'
    const towerStartIndex = fullText.lastIndexOf('(tower:');

    if (towerStartIndex === -1) {
      // If no tower info, just truncate whole text if needed
      const truncated =
        fullText.length > 5 ? fullText.slice(0, 5) + '...' : fullText;
      const group = new Group();
      group.append(
        new Text(truncated, [0, 0], {
          font: '12px Arial',
          fill: { color: '#000' },
        })
      );
      return group;
    }

    // Extract flatNo and tower separately
    const flatNo = fullText.substring(0, towerStartIndex).trim(); // everything before '(tower:'
    const tower = fullText.substring(towerStartIndex).trim(); // '(tower: ...)' and after

    // Truncate flatNo to 5 chars + '...' if longer
    const truncatedFlatNo =
      flatNo.length > 5 ? flatNo.slice(0, 5) + '...' : flatNo;

    const finalText = `${truncatedFlatNo} ${tower}`;
    //  console.log('finalText-------------->', finalText);

    const group = new Group();
    group.append(
      new Text(finalText, [0, 0], {
        font: '12px Arial',
        fill: { color: '#000' },
      })
    );

    return group;
  };

  labelEllipsisTemplateWithTooltip = (e: any) => {
    return new Text(e.text || '', [0, 0], {
      font: '12px Arial',
      fill: { color: '#000' },
    });
  };

  flatwiseConsumptionData() {
    // this.consuptuinUtility = value.name;
    this.topconsumptionData = [];
    //   console.log(this.topconsuptionSelectedUtilityType);
    const utilityType = this.topConsumptionList.find(
      (utility: any) =>
        utility.utilityType === this.topconsuptionSelectedUtilityType?.name
    );
    //  console.log(utilityType);

    if (utilityType) {
      if (this.consumptionminmaxvalue === 1) {
        this.topconsumptionData = [];
        // Top 5 Highest
        utilityType.top5Highest?.forEach((consumption: any, index: number) => {
          this.topconsumptionData.push({
            category: `${consumption.flatNo} (Twr: ${consumption.tower})`,
            value: consumption.totalConsumption,
            colorString: this.colorslist[index],
          });
        });
        this.topconsumptionLoader = false;
        //console.log('Top Consumption Data (Highest):', this.topconsumptionData);
      } else {
        // Top 5 Lowest
        this.topconsumptionData = [];
        utilityType.top5Lowest?.forEach((consumption: any, index: number) => {
          this.topconsumptionData.push({
            category: `${consumption.flatNo} (Twr: ${consumption.tower})`,
            value: consumption.totalConsumption,
            colorString: this.colorslist[index],
          });
        });
        this.topconsumptionLoader = false;
        // console.log('Top Consumption Data (Lowest):', this.topconsumptionData);
      }

      //});
    } else {
      this.topconsumptionLoader = false;
      console.log('No data found for the selected utility');
    }
  }

  getColor(index: number): string {
    // console.log(index);
    const colors = ['#E96360', '#DB6FA0', '#AD8AC0', '#6480BC', '#44C8F5'];
    let color = colors[index % colors.length];
    return color; // Cycle through colors
  }
  getSeriesColors(): string[] {
    return this.topconsumptionData[0]?.data.map((_: any, index: number) =>
      this.getColor(index)
    );
  }

  public labelContent(e: SeriesLabelsContentArgs): string {
    return e.value;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    // You can perform any action here if needed when the window resizes
    if (this.chart) {
      //console.log("resizes")
      this.chart?.updateOptions({
        chart: {
          width: '100%', // Ensure the chart width updates on window resize
        },
      });
    }
  }

  // yaxisUnits: string = 'Units';

  initChart(): void {
    //  console.log('this.convertedData--------------->', this.convertedData);
    const startDate = this.selectedDateRange?.startDate
      ? new Date(this.selectedDateRange.startDate)
      : null;
    const dateDiff =
      startDate && this.selectedDateRange?.endDate
        ? new Date(this.selectedDateRange.endDate).getTime() -
        startDate.getTime()
        : 0;
    // console.log(startDate)
    //  console.log(this.selectedDateRange?.endDate)
    this.yaxisUnits =
      this.consuptionSelectedUtilityType.name == 'Gas'
        ? 'Units (m³)'
        : this.consuptionSelectedUtilityType.name == 'DG'
          ? 'Units (kWh)'
          : this.consuptionSelectedUtilityType.name == 'EB'
            ? 'Units (kWh)'
            : 'Units (Liters)';

    // Choose the date format based on the date difference (2 months in milliseconds)
    const dateFormat =
      dateDiff > 2 * 24 * 60 * 60 * 1000 ? 'dd MMM' : 'dd MMM HH:mm';
    //  console.log(dateFormat)

    this.chartOptions = {
      series: [
        {
          name: '',
          data: this.convertedData,
        },
      ],
      chart: {
        type: 'area',
        height: 250,
        toolbar: { show: false },
        zoom: { enabled: false },
        events: {
          // mounted: (chart: any) => chart.windowResizeHandler(),
          dataPointMouseEnter: (event, chartContext, config) =>
            chartContext.chart.showTooltip(config.dataPointIndex),
          click: (event, chartContext, config) => {
            const dataPointIndex = config.dataPointIndex;
            if (dataPointIndex !== undefined) {
              this.handleDataPointClick(config.seriesIndex, dataPointIndex);
            }
          },
        },
      },
      colors: ['#008FFB'], // ✅ Add this line

      dataLabels: { enabled: false },
      markers: { size: 0 },

      // ✅ Added stroke (Fix)
      stroke: {
        curve: 'smooth',
        width: 2,
      },

      xaxis: {
        type: 'datetime',
          min: this.toTimestamp(this.selectedDateRange?.startDate),
        max: this.toTimestamp(this.selectedDateRange?.endDate),
        tickAmount: 3,
        title: { text: 'Dates' },
        labels: { format: dateFormat },
        tooltip: { enabled: false },
        crosshairs: { show: false },
      },

      yaxis: {
        title: { text: `${this.yaxisUnits}` },
      },

      tooltip: {
        x: { format: 'dd MMM yyyy' },
        y: { formatter: (value) => `${value}` },
      },

      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          stops: [0, 100],
        },
      },
    };
  }

  loadConsumptionChart() {
    this.consumptionData = [];
    //   console.log(this.consuptiongraphdata);
    // // console.log(this.consuptionSelectedUtilityType);
    const utilityData = this.consuptiongraphdata.find(
      (utility: any) =>
        utility.utilityMasterName === this.consuptionSelectedUtilityType.name
    );
    //  console.log(utilityData);
    if (utilityData) {
   const consumptionData = utilityData.totalConsumptionByDay ?? {};
      this.sumOfTotalConsumption = utilityData.sumOfTotalConsumption ?? 0;
      //   console.log(" this.sumOfTotalConsumption--------->", this.sumOfTotalConsumption)

      for (const date in consumptionData) {
        // this.sumOfTotalConsumption = this.consuptiongraphdata[0].sumOfTotalConsumption
        if (consumptionData.hasOwnProperty(date)) {
          const value = consumptionData[date];
          this.consumptionData.push({ category: date, value: value });
          // console.log(`category: "${date}", value: ${value}`);
        }
      }
        const convertedData = this.consumptionData
        .map((item) => this.toChartPoint(item.category, item.value))
        .filter((item): item is [number, number] => item !== null);

      if (convertedData.length == 0) {
        this.convertedData = [];
        this.consumptionData = [];
        this.consumptionLoader = false;
        return;
      }

      // console.log('Converted Data:', this.chartOptions.series);
      //  console.log(this.chartOptions);

      if (this.chartOptions.series && this.chartOptions.series[0].data) {
        this.chartOptions.series[0].data = [];

        //   console.log('convertedData test', convertedData);

        this.chartOptions.series[0].data = convertedData;
        this.convertedData = convertedData;

        this.consumptionLoader = false;
        this.initChart();
      }

      this.updateOptions(this.selectedRange);
      this.chart?.updateOptions(this.chartOptions, false, true, true); // Refresh chart
    } else {
      console.log(
        `Utility type "${this.consuptionSelectedUtilityType}" is not recognized.`
      );
    }

    setTimeout(() => {
      this.consumptionLoader = false;
    }, 200);
  }

  public updateOptions(option: keyof UpdateOptionsData): void {
    const optionData =
      this.updateOptionsData[option as keyof typeof this.updateOptionsData];
    if (optionData) {
      this.chart?.updateOptions(optionData, false, true, true);
    } else {
      console.log(`Option for '${option}' is undefined.`);
      // Handle undefined option case
    }
  }
private toTimestamp(value: any): number | undefined {
    if (!value) {
      return undefined;
    }

    const timestamp = new Date(value).getTime();
    return Number.isFinite(timestamp) ? timestamp : undefined;
  }

  private toChartPoint(category: any, value: any): [number, number] | null {
    const timestamp = this.toTimestamp(category);
    const numericValue = Number(value);

    if (timestamp == undefined || !Number.isFinite(numericValue)) {
      return null;
    }

    return [timestamp, numericValue];
  }
  billSummaryData(data: any) {
    //console.log(data);
    this.totalPrice;
    this.billSummary = [
      {
        label: 'Paid Bills',
        value: data.paidBillsCount,
        labelAmount: 'Paid Bills Amount',
        amount: data.paidBillsAmount,
        img: '../../../assets/images/Bill Paid ICON 03.svg',
        background: '#DAFFF2',
      },
      {
        label: 'Unpaid Bills',
        value: data.unpaidBillsCount,
        labelAmount: 'Unpaid Bills Amount',
        amount: data.unpaidBillsAmount,
        img: '../../../assets/images/Bill UnPaid ICON 02.svg',
        background: '#FFE5E5',
      },
      {
        label: 'Total Bills',
        value: data.totalBillCount,
        labelAmount: 'Total Bills Amount',
        amount: data.totlBillAmount,
        img: '../../../assets/images/Total Bill Icon 02.svg',
        background: '#FFEFCF',
      },
    ];
    if (this.billSummary.length > 0) {
      this.billSummaryLoader = false;
    }
  }
   private normalizeRole(role: string | undefined | null): string {
    return (role ?? '').toLowerCase().replace(/\s+/g, '');
  }

  /*   calculateTotals() {
      this.totalBill = this.billSummary.reduce(
        (sum: any, project: { bill: any }) => sum + project.bill,
        0
      );
      this.totalRevenue = this.billSummary.reduce(
        (sum: any, project: { revenue: any }) => sum + project.revenue,
        0
      );
    } */

  metreSttausData(data: any, type: any) {
    let filterdate = data?.deviceCounts?.filter((item: any) => {
      return item.utilityName.toUpperCase() === type.toUpperCase();
    });

    if (filterdate.length > 0) {
      this.totalMeterStatus = filterdate[0].totalCount;
      this.communicationMeterStatusGraphData = [
        { name: 'Active', value: filterdate[0].activeCount, color: '#6ED972' },
        {
          name: 'Inactive',
          value: filterdate[0].inActiveCount,
          color: '#F9AF58',
        },
      ];
    } else {
      this.communicationMeterStatusGraphData = [];
    }

    /* data?.deviceCounts.forEach((item: any) => {
      if (item.utilityName.toUpperCase() === type.toUpperCase()) {
        console.log(item);
        
      }
    }) */
  }
  communicationStatusData(data: any, type: any) {
    // console.log('dat---------------------->', data);
    //  console.log('type---------------------->', type);
    let commCount = 0;

    let actualNonCommCount = 0;
    let nonCommInactiveCount = 0;
    let nonCommMCBOffCount = 0;

    let filterdate = data?.deviceCounts.filter((item: any) => {
      //    console.log(item);
      return item.utilityName.toUpperCase() === type.toUpperCase();
    });
    // console.log('filterdate---------------------->', filterdate);
    if (filterdate.length > 0) {
      this.communicationStatusGraphData = [];
      (commCount = filterdate[0].commCount),
        (actualNonCommCount = filterdate[0].actualNonCommuCount),
        (nonCommInactiveCount = filterdate[0].nonCommInActiveCount),
        (nonCommMCBOffCount = filterdate[0].nonCommMCBOffCount);

      let tempData = [
        {
          category: 'Communicating',
          value: commCount,
          colorString: this.colors_status[1],
          comment: 'Meters actively communicating as of today',
        },
        {
          category: 'Non Communicating',
          value: actualNonCommCount,
          colorString: this.colors_status[2],
          comment: 'Meters not communicating as of today',
        },
        {
          category: 'Inactive',
          value: nonCommInactiveCount,
          colorString: this.colors_status[0],
          comment: 'Meters that have never been activated since installation',
        },
        {
          category: 'MCB Off',
          value: nonCommMCBOffCount,
          colorString: this.colors_status[3],
          comment: 'The MCB is turned off manually',
        },
      ];
      tempData.map((item: any) => {
        // Check if type is 'Electricity'
        if (type === 'Electricity' || type === 'TriSource') {
          this.communicationStatusGraphData.push(item);
        } else if (type !== 'Water' || type !== 'Gas') {
          // For any other type except 'Water' and 'Gas', push all items except 'MCB Off'
          if (item.category !== 'MCB Off') {
            this.communicationStatusGraphData.push(item);
          }
        }
      });

      if (this.communicationStatusGraphData.length > 0) {
        this.meterCommunicationStatus = true;
      }

      /*   console.log(
        'this.communicationStatusGraphData',
        this.communicationStatusGraphData
      ); */
    } else {
      this.communicationStatusGraphData = [];
      this.meterCommunicationStatus = false;
    }

    /*  this.communicationStatusGraphData = {
       commCount: commCount,
       nonCommCount: nonCommCount,
       nonCommInActiveCount: nonCommInActiveCount,
       nonCommMCBOffCount: nonCommMCBOffCount,
     }; */
    //  console.log('Non Communicating', this.communicationStatusGraphData);

    this.communicationStatusGraphData_temp = [
      {
        color: '#6ED972 ',
        name: `Non Communicating `,
      },
      {
        color: '#F9AF58',
        name: `Communicating`,
      },
    ];
  }

  get chartHeight(): number {
    return this.communicationStatusGraphData.length === 3 ? 246 : 225;
  }
  MeterStatusUtilityChange(event: any) {
    // console.log(event);
    if (event === undefined) {
      this.meterStatusUtility = '';
      this.totalMeterStatus = 0;
      this.communicationMeterStatusGraphData = [];
    } else {
      this.meterStatusUtility = event.id;
      this.metreSttausData(this.meterCommunicationList, event.name);
    }
  }
  selectedmeterCommunicationutility: any;
  utilityMeterChange(event: any) {
    this.meterUtilityType = event.id;
    this.selectedmeterCommunicationutility = event.name;
    //   console.log(event);
    if (event !== undefined) {
      this.communicationStatusData(this.meterCommunicationList, event.name);
    } else {
      this.communicationStatusGraphData = [];
      this.meterCommunicationStatus = false;
    }
  }
  getResidentialUnitData(data: any) {
    // console.log(data);
    this.totalResidentialUnits = data.totalUnits;

    this.residentialUnitsData = [
      { name: 'Occupied units', value: data.occupiedUnits, color: '#6ED972' },
      {
        name: 'Unoccupied units',
        value: data.unoccupiedUnits,
        color: '#F9AF58',
      },
    ];
    if (this.totalResidentialUnits == 0) {
      this.residentialUnitsData = [];
    }
    //console.log(this.residentialUnitsData);
  }

  listOfConsumers(data: any) {
    this.totalConsumers = data?.ownerCount + data?.tenantCount;
    this.consumerData = [
      { name: 'Owner', value: data?.ownerCount, color: '#6ED972' },
      { name: 'Tenant', value: data?.tenantCount, color: '#F9AF58' },
    ];
  }

  getClassBasedOnValue(): boolean {
    if (this.currentUserData?.currentUserRoleDetails?.role === Roles.ADMIN) {
      if (typeof this.currentUserData.project.billingType === 'object') {
        return (
          this.currentUserData.project.billingType.name === BillingType.PREPAID
        );
      } else if (typeof this.currentUserData.project.billingType === 'string') {
        return this.currentUserData.project.billingType === BillingType.PREPAID;
      }
      // console.log(this.currentUserData.project.billingType === BillingType.PREPAID)
      //return this.currentUserData.project.billingType === BillingType.PREPAID;
    }

    return false; // Return false if the role is not ADMIN or no match
  }

  getFormattedNumber(value: number): any {
    return this.decimalPipe.transform(value, '1.0-0');
  }

  private shouldBlockDashboardAdminNavigation(): boolean {
    return this.isDashboardAdmin;
  }

  onResidentialUnitsClick(event: any) {
    if (this.shouldBlockDashboardAdminNavigation()) {
      return;
    }
    this.router.navigate(['/residentialUnit']);
    const dataItem = event.dataItem; // Get the clicked data item
    const category = dataItem.name;
    const value = dataItem.value;
    //  console.log(dataItem)
    //  console.log(`Clicked on: ${category} with value: ${value}`);
    let residentialUnit = dataItem.name;
    let request = {
      residentialUnitStatus: residentialUnit,
      type: 'Admin_dashboard',
    };
    localStorage.removeItem('filter');
    this.router.navigate(['/residentialUnit'], {
      state: { residentialUnitRequest: request },
    });
  }
  onConsumersClick(event: any) {
    if (this.shouldBlockDashboardAdminNavigation()) {
      return;
    }
    const dataItem = event.dataItem; // Get the clicked data item
    const category = dataItem.name;
    const value = dataItem.value;
    
    // console.log(dataItem);
    //console.log(`Clicked on: ${category} with value: ${value}`);
    let residentialUnitStatus = dataItem.name;
    let request = {
      residentialUnitStatus: residentialUnitStatus,
      type: 'Admin_dashboard',
    };
    localStorage.removeItem('filter');
    this.router.navigate(['/residentialUnit'], {
      state: { residentialUnitRequest: request },
    });
  }

  getUTCMonthDateRangeWithinRange(
    dateRange: { startDate: string | Date; endDate: string | Date },
    selectedMonth: string
  ): { start: Date; end: Date } | null {
    const startDate = new Date(dateRange.startDate);
    const endDate = new Date(dateRange.endDate);

    const monthIndex = new Date(`${selectedMonth} 1, 2000`).getMonth();
    const possibleYears = [
      startDate.getUTCFullYear(),
      endDate.getUTCFullYear(),
    ];

    for (const year of possibleYears) {
      const monthStart = new Date(Date.UTC(year, monthIndex, 1));
      // const monthEnd = new Date(Date.UTC(year, monthIndex + 1, 0, 23, 59, 59, 999)); // Last moment of the month
      const monthEnd = new Date(Date.UTC(year, monthIndex + 1, 0));
      if (monthEnd >= startDate && monthStart <= endDate) {
        const start = monthStart < startDate ? startDate : monthStart;
        const end = monthEnd > endDate ? endDate : monthEnd;
        return { start, end };
      }
    }

    return null;
  }

  moreThen3months(event: any): void {
    if (this.shouldBlockDashboardAdminNavigation()) {
      return;
    }
    /*  console.log(event.point.category);
    console.log(this.selectedDateRange); */

    if (
      !this.selectedDateRange?.startDate ||
      !this.selectedDateRange?.endDate
    ) {
      console.warn('Date range is not properly defined');
      return;
    }

    const dateRange = {
      startDate: this.selectedDateRange.startDate,
      endDate: this.selectedDateRange.endDate,
    };

    const result = this.getUTCMonthDateRangeWithinRange(
      dateRange,
      event.point.category
    );

    //console.log(result);

    const request = {
      type: 'dashboardConsumption',
      month: event.point.category,
      UtilityType: this.consuptionSelectedUtilityType?.name,
      date: result,
    };

    this.router.navigate(['/reports'], {
      state: { consumptionItem: request },
    });
  }

  top5ConsumptionClick(event: any): void {
    if (this.shouldBlockDashboardAdminNavigation()) {
      return;
    }
    const clickedCategory = event.point.category;
    const clickedDataItem = this.topconsumptionData.find(
      (item) => item.category === clickedCategory
    );
    console.log(this.selectedRange)
    console.log('clickedCategory:', clickedCategory);
    console.log('clickedDataItem:', clickedDataItem); // Check if category exists

    // Check if the event contains a data point
    if (event && clickedDataItem) {
      console.log('clickedData', this.selectedDateRange);

      const flatNumberPart = clickedDataItem.category.split(' (Twr:')[0];
      const towerNumberPart = clickedDataItem.category
        .split('(Twr:')[1]
        ?.split(')')[0];
      //console.log(flatNumberPart);
      // console.log(towerNumberPart);
      const FlatNo = `${flatNumberPart.trim()} ${towerNumberPart.trim()}`;

      /* console.log('Extracted FlatNo:', FlatNo);
      console.log(
        'Clicked Data Point FlatNo:',
        this.topconsuptionSelectedUtility?.name
      ); */

      //const updatedFlatNo = FlatNo.replace('Twr', 'tower');
      // Prepare the request object
      const { startDate, endDate } = this.selectedDateRange || {};

      if (!endDate) return;

      let finalEndDate = new Date(endDate);

      // ✅ subtract 1 day only for current month
        if (this.selectedRange === 'Current Month') {
          finalEndDate.setDate(finalEndDate.getDate() - 1);
        }

      const updatedRange = {
        startDate,
        endDate: finalEndDate.toISOString(),
      };

      console.log(updatedRange);

      let request = {
        value: clickedDataItem.value,
        UtilityType: this.topconsuptionSelectedUtilityType?.name,
        flatNo: FlatNo,
        date: updatedRange,
        flag: false,
        type: 'top5Consumption',
      };

      // Navigate to the '/reports' page with the request object as state
      this.router.navigate(['/reports'], {
        state: { consumptionItem: request },
      });

      // this.router.navigate(['/maintenance'], {
      //   state: { consumptionItem: request },
      // });
    } else {
      console.warn('No data point clicked.');
    }
  }

  onMeterStatusClick(event: any) {
    if (this.shouldBlockDashboardAdminNavigation()) {
      return;
    }
    this.loaderService.setLoading(true);
    //  console.log(event)
    const seriesName = event.series.name;
    // console.log(event.series)
    let selectedutlity: any;
    // console.log(this.meterStatusUtility)
    // console.log(this.projectUtlityList)
    this.projectUtlityList.forEach((item: any) => {
      if (item.id == this.meterStatusUtility) {
        selectedutlity = item.name;
      }
    });

    // console.log(selectedutlity)
    const dataItem = event.dataItem; // Get the clicked data item
    const category = dataItem.name;
    const value = dataItem.value;

    // console.log(`Clicked on: ${category} with value: ${value}`);
    // let meterStatus = dataItem.name == 'Turn On' ? true : false;
    let meterStatus = dataItem.name == 'Active' ? 'Active' : 'Inactive';

    let request = {
      meterStatus: meterStatus,
      type: 'Admin_dashboard',
      utility: selectedutlity,
    };
    this.router.navigate(['/meters'], {
      state: { meterRequest: request },
    });
  }
  onMeterCommunicationStatusClick(event: any) {
    if (this.shouldBlockDashboardAdminNavigation()) {
      return;
    }
    const seriesIndex = event.series.index; // or event.seriesIndex depending on your Kendo version
    //console.log('event.series.index---------->', event.category);
    /*   console.log(
      'event.series.index---------->',
      this.selectedmeterCommunicationutility
    ); */
    let request = {
      value: event.category,
      type: 'superAdmin_Meter',
      utility: this.selectedmeterCommunicationutility,
    };
    this.router.navigate(['/meters'], {
      state: { meterRequest: request },
    });
  }
  onMeterCommunicationStatusClick_temp(event: any) {
    if (this.shouldBlockDashboardAdminNavigation()) {
      return;
    }
    // Get the index of the clicked series
    const seriesIndex = event.series.index; // or event.seriesIndex depending on your Kendo version
    //('event.series.index---------->', event.category);
    // Access the complete series data using the index
    //const clickedSeries = this.communicationStatusGraphData[seriesIndex];

    if (event.category == 'MCB Off') {
      let request = {
        value: event.category,
        type: 'Admin_Meter',
        status: 'Off',
        utility: this.selectedmeterCommunicationutility,
      };
      this.router.navigate(['/meters'], {
        state: { meterRequest: request },
      });
    } else {
      let request = {
        value: event.category,
        type: 'Admin_Meter',
        status: false,
        utility: this.meterUtilityType,
      };
      this.router.navigate(['/reports'], {
        state: { consumptionItem: request },
      });

      // this.router.navigate(['/maintenance'], {
      //   state: { consumptionItem: request },
      // });
    }
  }
  prepaidbillStatus(value: any) {
    if (this.shouldBlockDashboardAdminNavigation()) {
      return;
    }
    const today = new Date();

    // Get last day of previous month (local)
    const endDate = new Date(today.getFullYear(), today.getMonth(), 0); // e.g., June 30

    // Get first day of 6 months ago (local)
    const startDate = new Date(
      endDate.getFullYear(),
      endDate.getMonth() - 5,
      1
    ); // e.g., Jan 1

    const toDateString = (date: Date): string =>
      `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;

    this.selectedDateRange = {
      startDate: toDateString(startDate),
      endDate: toDateString(endDate),
    };

    console.log(this.selectedDateRange);
    const daterange = this.last3monthdDateRange()
    switch (value.label) {

      case 'Total Bills':

        let reportsRequest = {
          type: 'Wallet History',
          dateRange: daterange, // last 3 month date Range
        };
        // Logic for Total Bills
        this.router.navigate(['/reports'], {
          state: { consumptionItem: reportsRequest },
        });
        break;

      case 'Revenue':
        let WalletreportsRequest = {
          type: 'Wallet History',
          dateRange: daterange,
        };
        // Logic for Total Bills
        this.router.navigate(['/reports'], {
          state: { consumptionItem: WalletreportsRequest },
        });
        break;

      case 'Amount to be Collected':
        let request = {
          status: 'Dashboard',
        };
        this.router.navigate(['/wallet'], {
          state: { request: request },
        });
        // Logic for other label
        break;
    }
  }

  billStatus(value: any) {
    if (this.shouldBlockDashboardAdminNavigation()) {
      return;
    }
    let request = {
      billStatus: value.label,
      datarange: this.selectedDateRange,
    };

    this.router.navigate(['/bills'], {
      state: { request: request },
    });
  }

  handleDataPointClick(seriesIndex: number, dataPointIndex: number): void {
    if (this.shouldBlockDashboardAdminNavigation()) {
      return;
    }
    // console.log('Clicked Series Index:', seriesIndex);
    //onsole.log('Clicked Data Point Index:', dataPointIndex);

    // Check if series and data exist
    if (
      this.chartOptions.series &&
      this.chartOptions.series[seriesIndex] &&
      this.chartOptions.series[seriesIndex].data &&
      this.chartOptions.series[seriesIndex].data[dataPointIndex] !== undefined
    ) {
      // Get the selected data point
      const selectedData =
        this.chartOptions.series[seriesIndex].data[dataPointIndex];
      console.log(
        'Selected Data Point:',
        this.consuptionSelectedUtilityType?.name
      );
      // console.log('Selected Data Point:', selectedData);

      let request = {
        value: selectedData,
        UtilityType: this.consuptionSelectedUtilityType?.name,
        flag: true,
        type: 'Consumption',
        // date: this.selectedDateRange
      };

      this.router.navigate(['/reports'], {
        state: { consumptionItem: request },
      });

      // this.router.navigate(['/maintenance']);
      // Ensure selectedData is valid
    } else {
      console.log('Data point not found in series.');
    }
  }

  public onDataPointSelection(event: any): void {
    //  console.log(event);
    const dataPointIndex = event[0]?.dataPointIndex;
    const seriesIndex = event[0]?.seriesIndex;

    // Check if series and data exist
    if (
      this.chartOptions.series &&
      this.chartOptions.series[seriesIndex] &&
      this.chartOptions.series[seriesIndex].data &&
      this.chartOptions.series[seriesIndex].data[dataPointIndex] !== undefined
    ) {
      const selectedData =
        this.chartOptions.series[seriesIndex].data[dataPointIndex];
      //  console.log('Selected Data Point:', selectedData);

      // Perform additional actions here if needed
    } else {
      console.warn('Selected data point is undefined or does not exist.');
    }
  }

  maxMinValucChange(value: any) {
    if (value !== undefined) {
      //console.log(value);
      this.consumptionminmaxvalue = value.id;
      this.flatwiseConsumptionData();
      // this.consuprtionUtilitiesGrahChange(this.topconsuptionSelectedUtilityType.name);
    } else {
      this.topconsumptionData = [];
    }
  }

  consuprtionUtilitiesChange(value: any) {
    //  console.log(value);
    this.topconsumptionData = [];
    this.consuptionSelectedUtility = value.id;
    this.selectedUtilityType = value;
    this.consuptionSelectedUtilityType = value;
    //    this.consuprtionUtilitiesGrahChange(value.name);// top 5 consumption
    this.loadConsumptionChart();
  }
  utilitiesChangeConsumption(value: any) {
    //Consumption chart
    //console.log(value);
    // console.log(this.consuptionSelectedUtility);
    //  console.log(this.selectedRange);
    this.consuptionSelectedUtility = value.id;
    this.consuptionSelectedUtilityType = value; //bottom utility name Change
    this.yaxisUnits =
      this.consuptionSelectedUtilityType.name == 'Gas'
        ? 'Units (m³)'
        : this.consuptionSelectedUtilityType.name == 'Electricity'
          ? 'Units (kWh)'
          : 'Units (Liters)';

    if (
      this.selectedRange == 'Last Three Months' ||
      this.selectedRange == 'Last Six Months'
    ) {
      this.monthlyConsuptionChart();
    } else {
      this.loadConsumptionChart();
    }
  }

  utilitiesChange(value: any) {
    //  console.log(value);
    //  console.log(this.topconsuptionSelectedUtility);
    this.topconsuptionSelectedUtility = value.id;
    this.topconsuptionSelectedUtilityType = value; ////bottom utility name Change
    // console.log(this.topconsuptionSelectedUtilityType);
    this.flatwiseConsumptionData();
  }
}

interface DailyConsumption {
  [date: string]: number; // The date is a string and the consumption is a number
}

interface MonthlyConsumption {
  year: number;
  month: number;
  monthName: string;
  totalConsumptionForUtility: number;
}

interface UtilityData {
  utilityMasterName: string;
  sumOfTotalConsumption: any;
  totalConsumptionByDay: DailyConsumption;
}
